module.exports = __webpack_public_path__ + "static/images/components/RewardMoney/images/gold-large.3e903b49.png";


//////////////////
// WEBPACK FOOTER
// ./components/RewardMoney/images/gold-large.png
// module id = 2672
// module chunks = 11